import * as React from 'react';
import { MosaicKey } from 'react-mosaic-component/lib/types';

import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { ProjectDiagram } from 'src/containers/ProjectDiagram/ProjectDiagram';

type ProjectWorkspaceProps = {
  id: MosaicKey;
};

export const ProjectWorkspace: React.VFC<ProjectWorkspaceProps> = () => {
  return (
    <div className="sd-project-workspace">
      <ErrorBoundary>
        <ProjectDiagram />
      </ErrorBoundary>
    </div>
  );
};
